
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/b/[...url]",
      function () {
        return require("private-next-pages/b/[...url].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/b/[...url]"])
      });
    }
  